import { wrap as withStyle } from 'utils/styles'
import styled from '@emotion/styled'
import HoverableInfoIcon from 'components/patterns/HoverableInfoIcon'
import { getSizeValues } from '../utils'

export default withStyle((props) => {
  const { size, theme, vertical, weight } = props
  const { labelFontSize } = getSizeValues(size, theme)

  return `
    font-size: ${labelFontSize || 'inherit'};
    margin-bottom: ${vertical ? '2px' : '4px'};
    display: ${vertical ? 'block' : 'inline'};
    font-weight: ${weight};
    color: ${theme.inputFontColor || 'inherit'};
    &.mode-label {
      margin-right: 5px;
    }
  `
})

export const RequiredStyled = styled.span((props) => {
  const { theme } = props

  return `
    color: ${theme.inputRequiredWarning};
    margin-right: 3px;
  `
})

export const HintStyled = styled.span((props) => {
  const { theme } = props

  return `
    color: ${theme.suffixFontColor};
    display: inline-block;
    margin-left: 3px;
    font-weight: normal;
  `
})

export const HoverableInfoIconStyled = styled(HoverableInfoIcon)`
  svg.chec-icon--alert_info_i_round_solid {
    height: 12px;
    width: 12px;
  }
`
